export default __webpack_public_path__ + "static/media/icon-role-Developer.fdf263a8.svg";